/* eslint-disable */
/*
// Quick debug qualify, without a bet. Copy > paste in the JS console
(function() {
    var getLocalStorage = function(key) { return JSON.parse(window.localStorage.getItem(key)); }
    var setLocalStorage = function(key, obj) { window.localStorage.setItem(key, JSON.stringify(obj)); }
    var raceId = $('.js-RC-watchLiveButton').data('race-id');
    var bookmaker = ['bet365', 'coral', 'wh_oxi', 'ppwr', 'betfair', 'ladb', 'surrey'][ Math.round( Math.random() * 5 ) ];
    var race = { "race-id": raceId, "bookmaker": bookmaker, };
    var bet2view = getLocalStorage('bet2view') || {};
    bet2view.qualification = bet2view.qualification || [];
    bet2view.qualification.push( race );
    console.log('Quick qualify: ', race);
    setLocalStorage('bet2view', bet2view);
    window.bet2viewInitQualification && window.bet2viewInitQualification();
})();

  Logic for bet2view and Free livestream races
  - display bet2view or free livestream button (no qualify)
*/
import jQuery from 'jquery';
import Hls from 'hls.js';
import * as segmentio from 'rp-analytics';
import { mobileDetect } from 'rp-gui-guide';
import WatchLiveVideoControls from './watchLiveVideoControls';

const CHECK_LOCAL_STORAGE_TIMEOUT = 3 * 1000;
const CHECK_AJAX_TIMEOUT = 60 * 1000;
const REMOVE_TIMEOUT = 65 * 1000; // use some seconds more than CHECK_AJAX_TIMEOUT, to give other windows chance to remove the button

export default class WatchLive {
    constructor() {
        const defaultConfig = {
            selectors: {
                liveButton    : '.js-RC-watchLiveButton',
                howToBet      : '.js-RC-watchLiveHowToBet',
                content       : '.js-RC-watchLiveContent',
                text          : '.js-RC-watchLiveContent__text',
                video         : '.js-RC-watchLiveContent__video video',
                videoControls : '.js-RC-videoControls',
                loginToViewBtn : '.RC-loggedOutWatchLiveButton',
            },
            classes: {
                watchLiveTrigger          : 'RC-watchLiveButton--watchLiveTrigger',
                placeBetTrigger           : 'RC-watchLiveButton--placeBetTrigger',
                waitStartTrigger          : 'RC-watchLiveButton--waitStartTrigger',
                closeTrigger              : 'RC-watchLiveButton--closeTrigger',
                loaderTrigger             : 'RC-watchLiveButton--loaderTrigger',
                textContentTrigger        : 'RC-watchLiveContent--textContentTrigger',
                videoContentTrigger       : 'RC-watchLiveContent--videoContentTrigger',
                watchLiveHideBtn          : 'RC-watchLiveContent--buttonHide',
                showLogInToWatch          : 'RC-loggedOutWatchLiveButton--showLogInToWatch',
            },
            segmentioEvents: {
                howToBet    : 'How To Bet',
                started     : 'live_race_stream_started',
                paused      : 'live_race_stream_paused',
                interrupted : 'live_race_stream_interrupted', // not used for now
                resumed     : 'live_race_stream_resumed',
                completed   : 'live_race_stream_completed',   // not used for now
            },
            segmentioTraits: {
                TRAIT_STREAM_TYPE    : 'stream_type',
                TRAIT_RACECOURSE     : 'racecourse',
                TRAIT_RACE_TIME      : 'race_time',
                TRAIT_RACE_DATE      : 'race_date',
                TRAIT_PROVIDER       : 'provider',
                TRAIT_BOOKMAKER      : 'bookmaker',
                TRAIT_RACE_ID        : 'race_id',
                TRAIT_RACE_LOCATION  : 'location',
            },
            baseUrl: '/racecards/data/watch-live',
            performLauncherParams: "?_fmt=json&aLng=en-gb&_fld=sl,aLng,pa,sTok,mFmt,fst,fet,sst,set,lTyp,hs",
            notQualifiedMsg   : 'Sorry. You have to bet at least £1 on a race before you can view it.',
            raceNotStartedMsg : 'This stream will be live 2-3 minutes before the race starts. Try again later.',
            raceOverMsg       : 'This race has finished. See the results.',
            raceUnexpectedMsg : 'Sorry! We can\'t play this stream right now. Try again later.',
        };

        this.config = jQuery.extend(true, defaultConfig, WatchLive);

        this.$liveButton = jQuery(this.config.selectors.liveButton);
        this.$loginToViewBtn = jQuery(this.config.selectors.loginToViewBtn);
        this.$howToBet = jQuery(this.config.selectors.howToBet);
        this.$content = jQuery(this.config.selectors.content);
        this.$text = jQuery(this.config.selectors.text);
        this.$videoControls = jQuery(this.config.selectors.videoControls);

        this.trackHowToBet = this.trackHowToBet.bind(this);
        this.$howToBet.on('click', this.trackHowToBet);

        this.video = jQuery(this.config.selectors.video)[0];

        if (!this.video) return;

        this.isFreeLiveStream = this.$liveButton.data('race-stream-type') == "free";
        this.isLoginToViewStream = this.$liveButton.data('race-stream-type') == "login2view";

        this.rtvErrorMap = {
            "10001": {
                "text": "RTV Page not found."
            },
            "10300": {
                "text": "RTV Feed Access Denied."
            },
            "10316": {
                "text": "Live feed is Geoblocked."
            },
            "20210": {
                "text": this.config.raceNotStartedMsg
            },
            "20211": {
                "text": this.config.raceOverMsg
            }
        }

        document.addEventListener("BETSLIP.BOOKMAKER.LOGGED_IN", () => {
            this.toggleLoginToView(true);
        });

        document.addEventListener("BETSLIP.BOOKMAKER.LOGGED_OUT", () => {
            this.toggleLoginToView();
        });

        this.segmentConfiguration = this.config.segmentioEvents;

        this.video.addEventListener('playing', () => {
            if (this.skipFirstResumedEvent) {
                this.skipFirstResumedEvent = false;
                return;
            }
            this.trackWatchLive(this.segmentConfiguration.resumed);
        });
        this.video.addEventListener('pause', () => {
            this.trackWatchLive(this.segmentConfiguration.paused);
        });

        // default streamType -> bet2view
        this.segmentConfigStreamType = "bet";

        this.raceId = this.$liveButton.data('race-id');
        this.liveId = this.$liveButton.data('live-id');
        this.provider = this.$liveButton.data('provider');
        this.courseName = this.$liveButton.data('course-name');
        this.raceTime = this.$liveButton.data('race-time');
        this.raceDate = this.$liveButton.data('race-date');
        this.location = jQuery('[data-site-sub-section-2]').attr('data-site-sub-section-2');
        this.raceDateTime = jQuery('[data-card-race-date-time]').attr('data-card-race-date-time');
        this.bookmaker = ''; // will be set inside initQualification()
        this.userId = this.getUserId() || this.generateNewUserId();

        if(this.provider == 'ruk') {
            this.performUrl = this.$liveButton.data('perform-url');
        }

        this.abandoned = this.$liveButton.data('race-abandoned') === 'yes';
        this.finished = this.$liveButton.data('race-finished') === 'yes';

        // this.abandoned = this.finished = false; // debug
        // this.liveId = 1234; // debug

        this.$liveButton.on('click', this.loadVideoHandler.bind(this));

        this.hlsErrorHandler = this.hlsErrorHandler.bind(this);

        // free livestream  or bet2view data
        if(this.isFreeLiveStream){
            document.addEventListener("BETSLIP.BOOKMAKER.SET", (e) => {
              this.setFreeLivestreamBookmakerName(e.detail.bookmaker);
            });

            this.segmentConfigStreamType = "free";
            this.setFreeLivestreamBookmakerName();
            this.toggleFreeLivestreamUi();
            window.setInterval(this.toggleFreeLivestreamUi.bind(this), CHECK_AJAX_TIMEOUT);
        } else if(this.isLoginToViewStream){
            document.addEventListener("BETSLIP.BOOKMAKER.SET", (e) => {
                this.setLoggedInBookmaker(e.detail.bookmaker);
            });

            this.segmentConfigStreamType = "login";
            this.toggleLoginToView();
            this.checkLoginToWatcRaceStatus();

            let loginBtn = document.querySelector(this.config.selectors.loginToViewBtn);

            loginBtn.addEventListener("click", () => {
                window.location.href = '/my-bookmakers/';
            });

            window.setInterval(this.toggleLoginToView.bind(this), CHECK_AJAX_TIMEOUT);
            window.setInterval(this.checkLoginToWatcRaceStatus.bind(this), CHECK_AJAX_TIMEOUT);

        } else {
            this.initQualification();
            window.bet2viewInitQualification = this.initQualification.bind(this);
            window.setInterval(window.bet2viewInitQualification, CHECK_LOCAL_STORAGE_TIMEOUT);
            window.setInterval(this.checkQualification.bind(this), CHECK_AJAX_TIMEOUT);
        }
    }

    setLoggedInBookmaker(chosenBookmaker){
        const selectedBookmaker = chosenBookmaker.toUpperCase();
        const bookmakerInfoString = window.localStorage.getItem("userAccountsInfo");

        if(!bookmakerInfoString) return;

        let bookmakersInfo = JSON.parse(bookmakerInfoString);
        const isBookmakerFound = bookmakersInfo.hasOwnProperty(selectedBookmaker);

        if(isBookmakerFound && bookmakersInfo[selectedBookmaker]['isLoggedIn']){
            this.bookmaker = bookmakersInfo[selectedBookmaker]['feed'].toLowerCase();
        } else {
            for (let bookmaker in bookmakersInfo) {
                if(bookmakersInfo[bookmaker]['isLoggedIn'] == true){
                    this.bookmaker = bookmaker.toLowerCase();
                }
            }
        }
    }

    setFreeLivestreamBookmakerName(bookmakerName = ''){
        if(bookmakerName){
            this.bookmaker = bookmakerName;
            return;
        }

        const betslipInfoString = window.localStorage.getItem('persist:betslip');
        if(!betslipInfoString) return;

        const betslipInfo = JSON.parse(betslipInfoString);
        const bookmakerInfo = JSON.parse(betslipInfo.bookmakersInfo);
        this.bookmaker = bookmakerInfo.selectedBookmaker;
    }

    getFirstLoggedInBookmaker(){
        const bookmakerInfoString = window.localStorage.getItem("userAccountsInfo");

        if(!bookmakerInfoString) return '';

        let bookmakersInfo = JSON.parse(bookmakerInfoString);

        for (let bookmaker in bookmakersInfo) {
            if(bookmakersInfo[bookmaker]['isLoggedIn'] == true){
                return bookmaker.toLowerCase();
            }
        }

        return '';
    }

    getBookmakerNameFromFeed(feedName){
        const bookieName = feedName.toUpperCase();
        const feedBookieMap = {
            WH_OXI: 'williamHill',
            '#BESTODDS': 'bestOdds',
            LADB: 'ladbrokes',
            BET365: 'bet365',
            CORAL: 'coral',
            PPWR: 'paddypower',
            BETFAIR: 'betfair',
            VC: 'betVictor',
            // 'SPORTING INDEX': 'sportingBet',
            SURREY: 'skybet',
            BOLEYSPORTS: 'boylesport',
            TOTE: 'tote'
        }

        return feedBookieMap[bookieName] ? feedBookieMap[bookieName] : bookieName.toLowerCase();

    }

    isLoggedIn(){
        const bookmaker = this.getFirstLoggedInBookmaker();
        const is_logged_in = bookmaker !== '';

        return is_logged_in;
    }

    toggleLoginToView(eventLogin = false){

        if (this.isRaceAbondonedFinished()) return;

        this.bookmaker = this.getFirstLoggedInBookmaker();
        const isLoggedIn = eventLogin ? eventLogin : this.isLoggedIn();

        this.checkRaceStatusLoginToWatch(isLoggedIn);
    }

    initQualification() {
        this.toggleQualification();
        this.bookmaker = this.getBookmaker(this.raceId);
    }

    isRaceAbondonedFinished() {
        if (this.abandoned || this.finished) { // do not show the button on finished races
            this.$howToBet.css('display', 'none');
            this.$liveButton.removeClass(this.config.classes.watchLiveTrigger);
            this.$liveButton.removeClass(this.config.classes.placeBetTrigger);
            this.$liveButton.removeClass(this.config.classes.waitStartTrigger);
            return true;
        };
        return false;
    }

    toggleFreeLivestreamUi() {
        if (this.isRaceAbondonedFinished()) return;

        this.$howToBet.css('display', 'inline-block');
        this.checkRaceStatus();
    }

    toggleQualification() {
        if (this.isRaceAbondonedFinished()) return;

        this.$howToBet.css('display', 'inline-block');
        if (this.isQualified(this.raceId)) {
            this.checkRaceStatus();
        } else {
            this.$liveButton.removeClass(this.config.classes.watchLiveTrigger);
            this.$liveButton.addClass(this.config.classes.placeBetTrigger);
            this.$liveButton.removeClass(this.config.classes.waitStartTrigger);
        }
    }

    checkRaceStatus(){
        if (this.isRaceTime()) {
            this.$liveButton.addClass(this.config.classes.watchLiveTrigger);
            this.$liveButton.removeClass(this.config.classes.placeBetTrigger);
            this.$liveButton.removeClass(this.config.classes.waitStartTrigger);
        } else {
            this.$liveButton.removeClass(this.config.classes.watchLiveTrigger);
            this.$liveButton.removeClass(this.config.classes.placeBetTrigger);
            this.$liveButton.addClass(this.config.classes.waitStartTrigger);
        }
    }

    checkRaceStatusLoginToWatch(loginStatus){
      if(!this.isLoginToViewStream) return;

      if (this.isRaceTime()) {
            this.$liveButton.hide();
            this.$loginToViewBtn.css("display", "flex");
            if(!loginStatus) return;

            this.$liveButton.show();
            this.$loginToViewBtn.css("display", "none");
            this.$liveButton.addClass(this.config.classes.watchLiveTrigger);
            this.$liveButton.removeClass(this.config.classes.placeBetTrigger);
            this.$liveButton.removeClass(this.config.classes.waitStartTrigger);
      } else {
            if(!loginStatus){
                this.$liveButton.hide();
                this.$loginToViewBtn.css("display", "flex");
            } else {
                this.$loginToViewBtn.css("display", "none");
                this.$liveButton.addClass(this.config.classes.waitStartTrigger);
                this.$liveButton.show();
            }
        }
    }

    isQualified(raceId) {
        // return true; // debug
        var bet2view = this.getLocalStorage('bet2view') || {};
        var qualification = bet2view.qualification || [];
        for (var i = 0, len = qualification.length; i < len; i++) {
            var qualifiedBet = qualification[i];
            if (parseInt(qualifiedBet['race-id']) == parseInt(raceId)) {
                return true;
            }
        }
        return false;
    }

    isLoggedIn(){
        let status;
        const bookmakerInfoString = window.localStorage.getItem("userAccountsInfo");

        if(bookmakerInfoString === null ) return status = false;

        const bookmakersInfo = JSON.parse(bookmakerInfoString);

        for (let bookmaker in bookmakersInfo) {
            if(bookmakersInfo[bookmaker]['isLoggedIn'] == true){
                return status = true;
            }
        }

        return status = false;
    }

    isRaceTime() {
        // return true; // debug
        const numMinutesBeforeStart = 3;
        const raceTs = new Date(this.raceDateTime).getTime();
        const nowTs = Date.now();
        return raceTs - nowTs < numMinutesBeforeStart * 60 * 1000;
    }

    checkQualification() {
        // return; // debug
        var bet2view = this.getLocalStorage('bet2view') || {};
        if (!bet2view.qualification || !bet2view.qualification.length) return;
        if (!this.isRaceTime()) return;

        var qualifiedRaceIds = bet2view.qualification.map(race => race['race-id']).join(',');
        jQuery.ajax({
            method: 'GET',
            contentType: 'application/json; charset=utf-8',
            url: `${this.config.baseUrl}/status/${qualifiedRaceIds}?t=${Date.now()}` // no cache double securing
        }).done(data => {
            if (!data || !data.map ) return;
            data.map(race => {
                if (race['invalid'] || race['abandoned'] || race['finished']) {
                    if (parseInt(race['raceId']) === parseInt(this.raceId)) {
                        // stop video, exit full screen, remove button, remove how to bet link
                        WatchLiveVideoControls.exitFullScreen();
                        this.hideVideo();
                        this.finished = true;
                        this.toggleQualification();
                    }
                    window.setTimeout(() => { this.removeQualified(race['raceId']); }, REMOVE_TIMEOUT);
                }
            });
        });
    }

    checkLoginToWatcRaceStatus() {
        // return; // debug
        if (!this.isRaceTime()) return;

        jQuery.ajax({
            method: 'GET',
            contentType: 'application/json; charset=utf-8',
            url: `${this.config.baseUrl}/status/${this.raceId}?t=${Date.now()}` // no cache double securing
        }).done(data => {
            if (!data || !data.map ) return;
            data.map(race => {
                if (race['invalid'] || race['abandoned'] || race['finished']) {
                    if (parseInt(race['raceId']) === parseInt(this.raceId)) {
                        // stop video, exit full screen, remove button, remove how to bet link
                        WatchLiveVideoControls.exitFullScreen();
                        this.hideVideo();
                        this.finished = true;
                    }
                }
            });
        });
    }

    removeQualified(raceId) {
        var bet2view = this.getLocalStorage('bet2view') || {};
        if (!bet2view.qualification) return;
        bet2view.qualification = bet2view.qualification.filter((race) => {
            return parseInt(race['race-id']) !== parseInt(raceId);
        });
        this.setLocalStorage('bet2view', bet2view);

      }

    getLocalStorage(key) {
        return JSON.parse(window.localStorage.getItem(key));
    }

    setLocalStorage(key, obj) {
        window.localStorage.setItem(key, JSON.stringify(obj));
    }

    getBookmaker(raceId) {
        var nonExistingBookmaker = 'bookmaker_error';
        var bet2view = this.getLocalStorage('bet2view') || {};
        var qualification = bet2view.qualification || [];
        for (var i = 0, len = qualification.length; i < len; i++) {
            var qualifiedBet = qualification[i];
            if (parseInt(qualifiedBet['race-id']) == parseInt(raceId) && qualifiedBet['bookmaker']) {
                return qualifiedBet['bookmaker'];
            }
        }
        return nonExistingBookmaker;
    }

    getUserId() {
        var bet2view = this.getLocalStorage('bet2view') || {};
        return bet2view.uuid;
    }

    getBookmakerName(){
        let betslipInfo          = this.getLocalStorage('persist:betslip');
        let bookmakersInfo       = JSON.parse(betslipInfo.bookmakersInfo);

        return bookmakersInfo.selectedBookmaker.toLowerCase();
    }

    setUserId(uuid) {
        var bet2view = this.getLocalStorage('bet2view') || {};
        bet2view.uuid = uuid;
        this.setLocalStorage('bet2view', bet2view);
    }

    generateNewUserId() {
        var uuid = this.uuidv4();
        this.setUserId(uuid);
        return uuid;
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    isDesktop() {
        return !mobileDetect.isPhone() && !mobileDetect.tablet();
    }

    isIPhone() {
        return mobileDetect.os() === 'iOS' && mobileDetect.isPhone();
    }

    loadVideoHandler() {
        if (this.$liveButton.hasClass(this.config.classes.loaderTrigger)) {
            return;
        }

        if (
            this.$liveButton.hasClass(this.config.classes.placeBetTrigger) ||
            this.$liveButton.hasClass(this.config.classes.waitStartTrigger)
        ) {
            return;
        }

        if (this.$liveButton.hasClass(this.config.classes.closeTrigger)) {
            if (this.hls) {
                this.hideVideo();
            } else {
                this.hideText();
            }
            return;
        }

        if (this.$liveButton.hasClass(this.config.classes.placeBetTrigger)) {
            this.$liveButton.addClass(this.config.classes.closeTrigger);
            this.$text.text(this.config.notQualifiedMsg);
            this.$content.slideDown(300, () => {
                this.$content
                    .addClass(this.config.classes.textContentTrigger)
                    .removeClass(this.config.classes.videoContentTrigger);
            });
            return;
        }

        this.$liveButton.addClass(this.config.classes.loaderTrigger);
        var url = `${this.config.baseUrl}/${this.provider}/${this.liveId}/${this.userId}`;

        if (this.provider === 'ruk') {
            url = `${this.config.baseUrl}/${this.provider}/${this.userId}`;
            const bookmaker = this.bookmaker;
            const raceDateTimeBase64 = window.btoa(this.raceDateTime).replaceAll('=', '');

            url += '/' + bookmaker + '/' + raceDateTimeBase64;

            jQuery.ajax({
                method: 'GET',
                url: `${url}?t=${Date.now()}` // no cache double securing
            })
                .done(this.onLoadDataRtvSuccess.bind(this))
                .fail(this.onLoadVideoFail.bind(this))
                .always(this.onLoadVideoFinish.bind(this));
        } else {
            jQuery.ajax({
                method: 'GET',
                url: `${url}?t=${Date.now()}` // no cache double securing
            })
                .done(this.onLoadVideoSuccess.bind(this))
                .fail(this.onLoadVideoFail.bind(this))
                .always(this.onLoadVideoFinish.bind(this));
        }

        // Fullscreen API can be executed only on immediate user action (on click)
        if (!this.isIPhone() && !this.isDesktop()) {
            this.video.play();
            WatchLiveVideoControls.enterFullScreen(this.video);
        }
    }

    onLoadVideoFinish() {
        this.$liveButton.removeClass(this.config.classes.loaderTrigger);
    }

    onLoadVideoFail() {
        WatchLiveVideoControls.exitFullScreen();
        this.destroyHls();

        this.$text.text(this.config.raceUnexpectedMsg);

        this.$content.slideDown(300, () => {
            this.$content
                .addClass(this.config.classes.textContentTrigger)
                .removeClass(this.config.classes.videoContentTrigger);
        });
    }

    hideVideo() {
        this.$liveButton.removeClass(this.config.classes.closeTrigger);

        this.$content.slideUp(600, () => {
            this.destroyHls();
            this.$content
                .removeClass(this.config.classes.textContentTrigger)
                .removeClass(this.config.classes.videoContentTrigger)
        });
    }

    hideText() {
        this.$liveButton.removeClass(this.config.classes.closeTrigger);

        this.$content
            .removeClass(this.config.classes.textContentTrigger)
            .removeClass(this.config.classes.videoContentTrigger);
        this.$content.delay(600).slideUp(300, () => {
            this.$text.text('');
        });
    }

    destroyHls() {
        this.hls && this.hls.destroy();
        this.hls = null;

        this.destroyVideoControls();
    }

    destroyVideoControls() {
        this.videoControls && this.videoControls.destroy();
        this.videoControls = null;
    }

    removeProtocolFromUrl(url) { // http://aaa or https://aaa => //aaa
        // return url; // debug
        return url.replace(/^https?:\/\//g, '//');
    }

    checkForInternalErrors(data) {
        if (!data.success) {
            // console.log('error ', JSON.stringify(data));
            WatchLiveVideoControls.exitFullScreen();
            if (data.error === 'over') {
                this.$text.text(this.config.raceOverMsg);
            } else if (data.error === 'not started') {
                this.$text.text(this.config.raceNotStartedMsg);
            } else {
                this.$text.text(this.config.raceUnexpectedMsg);
            }
            this.$content.slideDown(300, () => {
                this.$content
                    .addClass(this.config.classes.textContentTrigger)
                    .removeClass(this.config.classes.videoContentTrigger);
            });

            return true;
        }

        return false;
    }

    // check Rtv Api error response
    // { "errorCode": "20211", "token": "esg9i21rnjh9b2ogj1lygk4c2" }
    onLoadRtvDataErrors(data) {
        WatchLiveVideoControls.exitFullScreen();
        this.destroyHls();

        try {
            const errorData = JSON.parse(data.responseText);
            const { errorCode } = errorData;
            const foundError = this.rtvErrorMap.hasOwnProperty(errorCode);

            if (foundError) {
                this.$text.text(this.rtvErrorMap[errorCode].text);
            } else {
                this.$text.text(this.config.raceUnexpectedMsg);
            }
        } catch (e) {
            this.$text.text(this.config.raceUnexpectedMsg);
        }

        this.$content.slideDown(300, () => {
            this.$content
                .addClass(this.config.classes.textContentTrigger)
                .removeClass(this.config.classes.videoContentTrigger);
        });
    }

    // check Rtv Api error response
    // manipulate data from livestreamlaunch
    extractRtvData(data) {
        if (!data || !data.launchInfo || !data.launchInfo.streamLauncher) {
            this.$text.text(this.config.raceUnexpectedMsg);

            this.$content.slideDown(300, () => {
                this.$content
                    .addClass(this.config.classes.textContentTrigger)
                    .removeClass(this.config.classes.videoContentTrigger);
            });

            return;
        }

        const { launchInfo: { streamLauncher } } = data;
        const { launcherURL } = streamLauncher.find(element => element.playerAlias === "iPhonesec");

        const rtvStreamData = {
            "success": true,
            "url": launcherURL
        };

        this.onLoadVideoSuccess(rtvStreamData);
    }

    // Passing accessToken Data for RTV livestream request
    onLoadDataRtvSuccess(data) {
        this.destroyHls();
        this.$liveButton.addClass(this.config.classes.closeTrigger);

        const internalErros = this.checkForInternalErrors(data);

        if(internalErros) {
            return;
        }

        const {
            accessToken,
            authKey,
            assetId
        } = data;

        jQuery.ajax({
            method: 'GET',
            url: `${this.performUrl}/livestreamlaunch/${authKey}/${assetId}/${this.config.performLauncherParams}`,
            headers: {
                "Authorization": `Bearer ${accessToken}`
            }
        })
            .done(this.extractRtvData.bind(this))
            .fail(this.onLoadRtvDataErrors.bind(this))
            .always(this.onLoadVideoFinish.bind(this));
    }

    // Passing ATR and RTV Livestream data
    onLoadVideoSuccess(data) {
        // data = { success: true, url: 'https://bitdash-a.akamaihd.net/content/MI201109210084_1/m3u8s/f08e80da-bf1d-4e3d-8899-f0f6155f6efa.m3u8' }; // debug
        // data = { success: true, url: 'http://94.56.35.254/live/default/Dubai_Racing/hlsv4/Dubai_Racing.m3u8' }; // debug

        if(this.provider !== 'ruk') {
            this.destroyHls();
            this.$liveButton.addClass(this.config.classes.closeTrigger);

            const internalErros = this.checkForInternalErrors(data);

            if(internalErros) {
                return;
            }
        }

        this.$text.text('');
        this.$content.slideDown(400, () => {
            this.$content
                .removeClass(this.config.classes.textContentTrigger)
                .addClass(this.config.classes.videoContentTrigger);
        });

        this.initControls();

        const loadedEvent = mobileDetect.os() === 'iOS' ? 'loadeddata' : 'loadedmetadata';
        this.video.addEventListener(loadedEvent, () => {
            this.video.play();
        });

        this.trackWatchLive(this.segmentConfiguration.started);
        this.skipFirstResumedEvent = true;


        const videoSrc = this.removeProtocolFromUrl(data.url);
        if (this.isIPhone()) {
            this.loadIPhoneVideo(videoSrc);
        } else {
            this.loadVideo(videoSrc);
        }
    }

    loadVideo(videoSrc) {
        this.video.src = videoSrc;
        this.withCredentialStatus = this.isFreeLiveStream;

        if (Hls.isSupported()) {
            this.hls = new Hls({ xhrSetup: (xhr, url) => { xhr.open('GET', this.removeProtocolFromUrl(url), true), xhr.withCredentials = this.withCredentialStatus }, startLevel: 3 });
            this.hls.loadSource(videoSrc);
            this.hls.attachMedia(this.video);

            this.hlsManifestParsed = false;
            this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                this.hlsManifestParsed = true;
                this.video.play();
            });

            this.hlsNetworkErrorRecoverCount = 0;
            this.hls.on(Hls.Events.ERROR, this.hlsErrorHandler);
        }
    }

    loadIPhoneVideo(videoSrc) {
        window.location = videoSrc;
    }

    initControls() {
        let hasCustomControls = this.isDesktop();
        // hasCustomControls = false; // debug

        if (hasCustomControls) {
            this.$videoControls.show();
            this.videoControls = new WatchLiveVideoControls();
        } else {
            this.$videoControls.hide();
            this.video.controls = true;
        }
    }

    hlsErrorHandler(event, data) {
        var errorType = data.type;
        var errorDetails = data.details;
        var errorFatal = data.fatal;
        if (!data.fatal) {
            return;
        }
        // console.log('FATAL error! ');
        switch(data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
                // try to recover network error
                // console.log("Fatal network error encountered, trying to recover...");
                this.hlsNetworkErrorRecoverCount++;
                if (this.hlsNetworkErrorRecoverCount >= 1) {
                    // console.log("Max number of recovering Network fatal errors reached, destroying");
                    WatchLiveVideoControls.exitFullScreen();
                    this.hideVideo();
                    break;
                }
                if (this.hlsManifestParsed) {
                    // console.log('Recover network error', this.hls);
                    this.hls && this.hls.startLoad();
                } else {
                    // console.log("Network fatal error cannot recover, destroying");
                    WatchLiveVideoControls.exitFullScreen();
                    this.hideVideo();
                }
                break;
            case Hls.ErrorTypes.MEDIA_ERROR:
                // console.log("Fatal media error encountered, try to recover");
                this.hls && this.hls.recoverMediaError();
                break;
            default:
                // console.log("Cannot recover fatal error encountered, destroying");
                WatchLiveVideoControls.exitFullScreen();
                this.hideVideo();
                break;
        }
    }

    // used for bet2view and free livestream
    trackWatchLive(segmentioEvent) {
        const bookmaker_ = this.getBookmakerNameFromFeed(this.bookmaker);

        const traits = {
            [this.config.segmentioTraits.TRAIT_RACECOURSE ] : this.courseName,
            [this.config.segmentioTraits.TRAIT_STREAM_TYPE ]: this.segmentConfigStreamType,
            [this.config.segmentioTraits.TRAIT_RACE_TIME  ] : this.raceTime,
            [this.config.segmentioTraits.TRAIT_RACE_DATE  ] : this.raceDate,
            [this.config.segmentioTraits.TRAIT_PROVIDER   ] : this.provider.toUpperCase(),
            [this.config.segmentioTraits.TRAIT_BOOKMAKER  ] : bookmaker_,
        }
        segmentio.track(segmentioEvent, traits);
    }

    trackHowToBet() {
        let eventName     = this.config.segmentioEvents.howToBet;
        const traits = {
            [this.config.segmentioTraits.TRAIT_RACE_LOCATION ]: this.location,
            [this.config.segmentioTraits.TRAIT_RACE_ID       ]: this.raceId,
            [this.config.segmentioTraits.TRAIT_RACECOURSE    ]: this.courseName,
            [this.config.segmentioTraits.TRAIT_RACE_DATE     ]: this.raceDate,
            [this.config.segmentioTraits.TRAIT_RACE_TIME     ]: this.raceTime,
        }
        segmentio.track(eventName, traits);
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/watchLive.js